// extracted by mini-css-extract-plugin
export default {"survey_title":"index_survey_title_cqceu","box":"index_box_7nONt","logo":"index_logo_mxSh5","icon":"index_icon_70Is-","title":"index_title_j2Z4-"};